import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@vectord/components';

import {
  DELETE_CLASS_REASON_OPTIONS,
  sbatGroupBulkUpdateCommunicationsSelector,
  sbatGroupBulkUpdateReasonSelector,
  setSbatGroupBulkUpdateCommunications,
  setSbatGroupBulkUpdateReason,
} from 'features/classCreation';
import BulkDeleteSbatGroupsButton from '../BulkDeleteSbatGroupsButton';
import SectionHeading from 'components/SectionHeading';
import Select from 'components/Select';
import SelectNotificationMode from 'components/SelectNotificationMode';
import SelectedSbatGroupsForBulkUpdate from '../SelectedSbatGroupsForBulkUpdate';
import styles from './BulkDeleteSbatGroupModalInfoStage.module.scss';

export default function BulkDeleteSbatGroupModalInfoStage() {
  const dispatch = useDispatch();
  const communications = useSelector(sbatGroupBulkUpdateCommunicationsSelector);
  const deleteReason = useSelector(sbatGroupBulkUpdateReasonSelector);

  const handleCommsToggle = useCallback(
    (commType) => {
      dispatch(
        setSbatGroupBulkUpdateCommunications({
          channel: commType,
          enabled: !communications[commType],
        })
      );
    },
    [communications, dispatch]
  );

  const handleReasonChange = useCallback(
    (option) => {
      dispatch(setSbatGroupBulkUpdateReason(option));
    },
    [dispatch]
  );

  return (
    <>
      <SectionHeading
        title={
          <>
            <Icon
              name="trash"
              className="danger h2 m-r-xxs"
            />
            Delete Classes
          </>
        }
        titleClassName={styles.heading}
        className={styles.sectionHeading}
        subtitle="The following classes will be deleted but comms will be sent only for
        the next class."
      />
      <SelectedSbatGroupsForBulkUpdate />
      <Select
        className="m-b-s"
        placeholder="Select a reason for class deletion"
        options={DELETE_CLASS_REASON_OPTIONS}
        value={deleteReason}
        onChange={handleReasonChange}
      />
      <SelectNotificationMode
        communications={communications}
        handleCommsToggle={handleCommsToggle}
      />
      <div className={styles.hintText}>
        Are you sure you want to delete the selected classes?
      </div>
      <BulkDeleteSbatGroupsButton />
    </>
  );
}
